import type { Result } from 'neverthrow';

import { apiRequest, type ApiError } from './client';

/**
 * Ship-from address as the SPA sees it. Mirrors the backend
 * `ShipFromAddressSchema` but kept as a manual interface so the
 * frontend stays dependency-free of the Lambda packages.
 */
export interface ShipFromAddress {
  readonly address_id: string;
  readonly tenant_id: string;
  readonly created_at: string;
  readonly line1: string;
  readonly line2?: string;
  readonly city: string;
  readonly state?: string;
  readonly postal_code: string;
  readonly country: string;
}

/**
 * Body for `POST /ship-from-addresses` — the same fields minus the
 * server-managed ones.
 */
export interface ShipFromAddressCreate {
  readonly line1: string;
  readonly line2?: string;
  readonly city: string;
  readonly state?: string;
  readonly postal_code: string;
  readonly country: string;
}

/**
 * Body for `PATCH /ship-from-addresses/{id}` — partial.
 */
export interface ShipFromAddressUpdate {
  readonly line1?: string;
  readonly line2?: string;
  readonly city?: string;
  readonly state?: string;
  readonly postal_code?: string;
  readonly country?: string;
}

export function createShipFromAddress(
  input: ShipFromAddressCreate,
): Promise<Result<ShipFromAddress, ApiError>> {
  return apiRequest<ShipFromAddress>({
    method: 'POST',
    path: '/ship-from-addresses',
    body: input,
  });
}

export function updateShipFromAddress(
  addressId: string,
  updates: ShipFromAddressUpdate,
): Promise<Result<ShipFromAddress, ApiError>> {
  return apiRequest<ShipFromAddress>({
    method: 'PATCH',
    path: `/ship-from-addresses/${addressId}`,
    body: updates,
  });
}
